/**
 * GZOO AI Marketing — Agency API (Wave 6 Phase 2).
 *
 * An agency org owns client orgs. This module fronts the agency status, enabling agency mode,
 * the client roster, and creating a client. Entering a client uses the existing
 * switch-organization flow (now agency-aware on the backend).
 */
import { apiClient } from './client';

export interface AgencyStatus {
  organization_id: string;
  is_agency: boolean;
  client_count: number;
}

export interface AgencyClient {
  id: string;
  name: string;
  slug: string;
  logo_url: string | null;
  member_count: number;
  publishing_disabled: boolean;
  created_at: string;
}

export async function fetchAgencyStatus(): Promise<AgencyStatus> {
  const { data } = await apiClient.get('/agency/status');
  return data;
}

export async function enableAgency(): Promise<AgencyStatus> {
  const { data } = await apiClient.post('/agency/enable');
  return data;
}

export async function fetchAgencyClients(): Promise<AgencyClient[]> {
  const { data } = await apiClient.get('/agency/clients');
  return data;
}

export async function createAgencyClient(name: string): Promise<AgencyClient> {
  const { data } = await apiClient.post('/agency/clients', { name });
  return data;
}
